
import React from 'react';
export const TrainingContext = React.createContext({});